<script lang="ts">
    import RecommendationsSlide from 'desktop/components/recommendationsCarousel/recommendationsSlide/RecommendationsSlide.svelte';
    import type {ProductRecommendationType} from 'types/dy';
    import emblaCarouselSvelte from 'embla-carousel-svelte';
    import type {EmblaCarouselType} from 'embla-carousel-svelte';
    import ArrowLeft from 'desktop/icons/ArrowLeft.svelte';
    import ArrowRight from 'desktop/icons/ArrowRight.svelte';
    import s from './style.module.css';
    import {
        SLIDES_SHOWN,
        EMBLA_OPTIONS,
    } from 'desktop/templates/squareExitRecommendations/constants';
    import {pushPopupEvent} from 'general/libs/pushDataLayer';

    export let recommendations: ProductRecommendationType[];

    let emblaApi: EmblaCarouselType;
    let isPrevDisabled = true;
    let isNextDisabled = false;

    const preventEdgeScrolling = embla => {
        const {limit, target, scrollTo, scrollSnaps} = embla.internalEngine();

        return () => {
            limit.min = scrollSnaps[recommendations.length - SLIDES_SHOWN] - 1;
            if (target.get() < limit.min) {
                target.set(limit.min);
                scrollTo.distance(0, false);
            }
            checkPrevScroll();
            checkNextScroll();
        };
    };

    const onInit = (event: CustomEvent<EmblaCarouselType>) => {
        emblaApi = event.detail;
        emblaApi.on('scroll', preventEdgeScrolling(emblaApi));
    };

    const checkPrevScroll = () => {
        isPrevDisabled = !emblaApi.canScrollPrev();
    };

    const checkNextScroll = () => {
        isNextDisabled = emblaApi.slidesInView(true)[2] === recommendations.length - 1;
    };

    const scrollPrev = () => {
        pushPopupEvent('scroll');
        emblaApi.scrollPrev();
    };

    const scrollNext = () => {
        pushPopupEvent('scroll');
        emblaApi.scrollNext();
    };
</script>

{#if recommendations?.length}
    <div class={s.container}>
        <div use:emblaCarouselSvelte={{options: EMBLA_OPTIONS, plugins: []}} on:emblaInit={onInit}>
            <div class={s.carousel}>
                {#each recommendations as product}
                    <RecommendationsSlide {product} index={recommendations.indexOf(product)} />
                {/each}
            </div>
        </div>
        <button
            class="{s.prev} {isPrevDisabled && s.disabled}"
            on:click={scrollPrev}
            disabled={isPrevDisabled}
        >
            <ArrowLeft color={isPrevDisabled ? '#aaa' : '#5B6971'} />
        </button>
        <button
            class="{s.next} {isNextDisabled && s.disabled}"
            on:click={scrollNext}
            disabled={isNextDisabled}
        >
            <ArrowRight color={isNextDisabled ? '#aaa' : '#5B6971'} />
        </button>
    </div>
{/if}
